<ul>
   <li id="menu-item-my-account">
      <a data-testid="nav-link-myAccount" [routerLink]="'/ng/account/overview'" [class.active]="activeRoute.endsWith('/ng/account/overview')">
         <span> {{'MC_MNU_HOME' | translate}} </span>
      </a>
   </li>

   @if (customerIsPartner) {
   <li id="menu-item-customers">
      <a data-testid="nav-link-customers" [routerLink]="'/ng/account/customers'" [class.active]="activeRoute.includes('/ng/account/customers') || activeRoute.includes('/ng/account/overview/')">
         <span> {{'MC_MNU_CUSTOMERS' | translate}} </span>
      </a>
   </li>
   }

   <li id="menu-item-products">
      <a data-testid="nav-link-products" [routerLink]="'/ng/products/overview'" [class.active]="activeRoute.startsWith('/ng/products/')">
         <span [innerHtml]="'MC_MNU_PRODUCT_OVERVIEW' | translate"></span>
      </a>
   </li>

   <li id="menu-item-separator"></li>

   <li id="menu-item-domains">
      <a data-testid="nav-link-domains" [routerLink]="'/ng/domain/overview'" [class.active]="activeRoute.includes('/ng/domain')">
         <span> {{'MC_MNU_DOMAINS' | translate}} </span>
      </a>
   </li>

   <li id="menu-item-m365">
      <a data-testid="nav-link-m365" [routerLink]="'/ng/shared-hosting/m365'" [class.active]="activeRoute.includes('/ng/shared-hosting/m365') || activeRoute.includes('/ng/m365')">
         <span> {{'MC_DOMAIN_NAVIGATION_M365' | translate}} </span>
      </a>
   </li>

   <li id="menu-item-mail">
      <a data-testid="nav-link-mail" [routerLink]="'/ng/shared-hosting/mail'" [class.active]="activeRoute.includes('/ng/shared-hosting/mail') || activeRoute.includes('/ng/linux/postfix')">
         <span> {{'MC_DOMAIN_NAVIGATION_MAIL_HOSTING' | translate}} </span>
      </a>
   </li>

   <li id="menu-item-cms">
      <a data-testid="nav-link-cms" [routerLink]="'/ng/shared-hosting/cms'" [class.active]="activeRoute.includes('/ng/shared-hosting/cms') || (activeRoute.includes('/ng/linux') && !activeRoute.includes('/ng/linux/postfix'))">
         <span> {{'MC_DOMAIN_NAVIGATION_CMS_WEBHOSTING' | translate}} </span>
      </a>
   </li>

   <li id="menu-item-servers">
      <a data-testid="nav-link-servers" [routerLink]="'/ng/data-center/cloud/overview'" [class.active]="activeRoute.includes('/ng/data-center/cloud/overview')">
         <span> {{'MC_DOMAIN_NAVIGATION_SERVER_HOSTING' | translate}} </span>
      </a>
   </li>

   <li id="menu-item-ssl">
      <a data-testid="nav-link-ssl" [routerLink]="'/ng/ssl-certificates/overview'" [class.active]="activeRoute.includes('/ng/ssl-certificates')">
         <span> {{'MC_DOMAIN_NAVIGATION_SSL_CERTIFICATES' | translate}} </span>
      </a>
   </li>

   <li id="menu-item-separator"></li>

   <li id="menu-item-invoices">
      <a data-testid="nav-link-invoices" [routerLink]="'/ng/documents/overview'" [class.active]="activeRoute.includes('/ng/documents/overview')">
         <span> {{'MC_MNU_INVOICES_OVERVIEW' | translate}} </span>
      </a>
   </li>

   <li id="menu-item-promotions">
      <a data-testid="nav-link-promotions" [routerLink]="'/ng/promotions/overview'" [class.active]="activeRoute.includes('/ng/promotions/overview')">
         <span> {{'MC_MNU_PROMO' | translate}} </span>
      </a>
   </li>

   <li id="menu-item-subscriptions">
      <a data-testid="nav-link-subscriptions" [routerLink]="'/ng/subscriptions/overview'" [class.active]="activeRoute.includes('/ng/subscriptions')">
         <span> {{'MC_MNU_ORDERS' | translate}} </span>
      </a>
   </li>

   <li id="menu-item-separator"></li>

   <li id="menu-item-tickets">
      <a data-testid="nav-link-tickets" [routerLink]="'/ng/tickets'" [class.active]="activeRoute.includes('/ng/tickets')">
         <span> {{'MC_MNU_TICKETS_NEW' | translate}} </span>
      </a>
   </li>
</ul>